module.exports = __webpack_public_path__ + "img/Patent_4.3c2afb1f.png";